module.exports = global.config = {
    apiKey : 'IPPWCC2CUGX8Q4H55JTD9VDZMCT7LT6L',
    domain_url:"https://www.kimiagoldgallery.com",
    webhesab_url:"http://erp.kimiagoldgallery.com"
}